import { PatchNotes } from "../../types/patches";

export const patch: PatchNotes = {
  id: "patch-11.0.782-season-eight",
  buildId: "11.0.782",
  name: "Season Eight Update",
  season: 8,
  type: "update",
  officialUrl: "https://www.ageofempires.com/news/age-of-empires-iv-update-11-0-782/",
  summary: "",
  introduction: `
![](https://cdn.ageofempires.com/aoe/wp-content/uploads/2024/07/S8_Update_Banner-1-1080x608.webp)
"Hello, and welcome to Season Eight, where we’re celebrating warm weather and good friends, as well as preparing for the return of our Map Monsters, the Wild Man and Dragon Turtle!"`,
  date: new Date("2024-07-18T18:00:00Z"),
  sections: [

  ],
};
